import React, { useEffect, useState } from "react";
import "./UnReviewedOrders.css";
import dealBackIcon from "../../../../src/images/dealBackIcon.svg";
import Search from "./Search";
import { connect } from "react-redux";
import * as actions from "../actions";
import Pagination from "../../../components/Pagination";
import OrderRow from "./OrderRow";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { routePrefix } from "../../../config";
const UnReviewedOrders = ({
  unReviewedList = [],
  getUnReviewedOrders,
  totalUnReviewedList,
  toggleAskForReviews,
  history,
}) => {
  const [source, setSource] = useState({ name: "" });
  const [destination, setDestination] = useState({ name: "" });
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    getUnReviewedOrders({ pageNo: 1, limit: 1 }, false);
    return () => toggleAskForReviews(false);
  }, []);


  const handlePageChange = (pageNo) => {
    let query = {
      pageNo: pageNo,
      limit: pageNo,
      paytm_src_id: source.city_id,
      paytm_dest_id: destination.city_id,
    };
    setCurrentPage(pageNo);

    getUnReviewedOrders(query, false);
  };

  const handleSource = (source) => {
    setSource(source);
  };

  const handleDestination = (destination) => {
    setDestination(destination);
  };

  const handleCurrentPage = (pageNo) => {
    setCurrentPage(pageNo);
  };

  const handleDealBackButtonClick = () => {    
    history.push(routePrefix + '/ratings-reviews');
    toggleAskForReviews(false);
  }

  return (
    <div className="passengerDetails">
      <div className="passengerDetailsHeader">
      <Link to={routePrefix + '/ratings-reviews'}>
        <img src={dealBackIcon} className="backArrow" alt="dealBackIcon" onClick={handleDealBackButtonClick}/>
      </Link>
      <h1>Ask for Review</h1>
      </div>
      <div className="tableContainer">
        <div className="searchContainer">
          <Search
            getUnReviewedOrders={getUnReviewedOrders}
            source={source}
            destination={destination}
            handleSource={handleSource}
            handleDestination={handleDestination}
            handleCurrentPage={handleCurrentPage}
          />
        </div>
        {unReviewedList.length > 0 ? (
          <Pagination
            totalPages={Math.ceil(totalUnReviewedList / 10)}
            currentPage={currentPage}
            onPageChange={(page) => handlePageChange(page)}
          />
        ) : null}
        {unReviewedList.length > 0 ? (
          <div className="review-table">
            <table>
              <thead>
                <tr className="tableHeading">
                  <th>Passenger Name</th>
                  <th>PNR</th>
                  <th>Source - Destination</th>
                  <th>Date of Journey</th>
                  <th>Phone Number</th>
                  <th>Call Status</th>
                  <th>Send link for Review</th>
                </tr>
              </thead>
              <tbody>
                {unReviewedList.map((row, index) => (
                  <OrderRow row={row} index={index} unReviewedList={unReviewedList} />
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="noDataFound">
            <h1>No Data Found!</h1>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  unReviewedList: store.ratingsReducer.unReviewedList,
  totalUnReviewedList: store.ratingsReducer.totalUnReviewedList,
  notificationStatus: store.ratingsReducer.notificationStatus,
});

const mapDispatchToProps = (dispatch) => ({
  getUnReviewedOrders: (query, isNewQuery) => dispatch(actions.getUnReviewedOrders(query, isNewQuery)),
  toggleAskForReviews: (query) => dispatch(actions.toggleAskForReviews(query)),
});

UnReviewedOrders.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(UnReviewedOrders);